import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=1174986e&scoped=true&"
import script from "./OrderRefund.vue?vue&type=script&lang=js&"
export * from "./OrderRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1174986e",
  null
  
)

export default component.exports